module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#fig1"
    }
  }, [_vm._v("Fig 1")]), _vm._v(": Map by Ian & Judith Wilson modified from data & a more detailed map in Frank Press & Raymond Siever, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Earth")]), _vm._v(" (4th ed.) New York, W.H. Freeman, 1986, p.254; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#fig2"
    }
  }, [_vm._v("Fig 2")])]), _vm._v(": Based on a graph reproduced on the website of Claude Lantz, after Jacques Labeyrie, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("L’homme et le climat,")]), _vm._v(" Denoël, Paris; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#fig4"
    }
  }, [_vm._v("Fig 4")])]), _vm._v(": From a photograph of the 1920s in the University of Pennsylvania Museum Archives; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#fig5"
    }
  }, [_vm._v("Fig 5")])]), _vm._v(": Supplied courtesy of Prof. Ian Plimer of the University of Melbourne; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 7")])]), _vm._v(": From the web-site of the Institute for Exploration, Mystic, Connecticut, reproduction permission kindly granted by Dr. Fredrik Hiebert, University of Pennsylvania Museum; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 8")])]), _vm._v(": Map by Ian & Judith Wilson based on data and a map in Tjeerd van Andel’s scientific paper ‘Late Quaternary sea-level changes and archaeology’ "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Antiquity")]), _vm._v(" 63 (1989) pp.733–45; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 9")])]), _vm._v(": From a painting of the Henri Lhote Tassili expedition; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figs 10")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#fig21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" (right), "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#fig22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" & "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#fig23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(": Drawings and photographs supplied by kind permission of Dr. James Mellaart; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 11")])]), _vm._v(": Drawing supplied courtesy of Dr.Denise Schmandt-Besserat and the University of Texas; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 17")])]), _vm._v(": Map by Ian & Judith Wilson based on data and maps in William Ryan & Walter Pitman’s "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Noah’s Flood,")]), _vm._v(" New York, Simon & Schuster, 1998, pp.189 & 194; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#fig19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 19")])]), _vm._v(": (left) N.Vlassa, (right) Ashmolean Museum, Oxford; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figs 20")]), _vm._v(" & "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#fig26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(":")]), _vm._v(" photos by Ian Wilson; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#fig21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 21")])]), _vm._v(" (left): Photo Mario Mintoff, courtesy M.J. Publications, Malta; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#fig24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 24")])]), _vm._v(": Ankara Museum; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#fig25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 25")])]), _vm._v(": Map by Ian & Judith Wilson based on a map in Keith Muckelroy (ed.) "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Archaeology Under Water")]), _vm._v(" New York, McGraw Hill, 1980, pp.162–2; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#fig27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 27")])]), _vm._v(": Directorate of Antiquities, Baghdad; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#fig30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figs 30")]), _vm._v(" & "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#fig31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v("; Heraklion Museum, Crete; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#fig32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 32")])]), _vm._v(": Ekdotike Athenon; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#fig33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 33")])]), _vm._v(": Max Hirmer; "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#fig34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 34")])]), _vm._v(": Archaeological Museum, Damascus. "), _c('span', {
    staticClass: "epub-i"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 12")])]), _vm._v(": Drawing from Alastair Hull’s "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Living with Kilims,")]), _vm._v(" Thames & Hudson, 1988, p.35, courtesy Thames & Hudson.’")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("Whilst every reasonable effort has been made to contact copyright owners, the author & publishers apologise in the case of any that have been untraceable and will be pleased to insert appropriate acknowledgement in future editions.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1259d92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 69
// module chunks = 0